"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_bootstrap_1 = require("react-bootstrap");
const URLs_1 = require("../utility/URLs");
const URLs_2 = require("../utility/URLs");
const helpers_1 = require("../../commonFiles/helpers");
const PageContentEditor_1 = __importDefault(require("../components/PageContentEditor"));
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
const SelectWithApiSearch_1 = __importDefault(require("../components/SelectWithApiSearch"));
function PageCreator(props) {
    const [page_content, setpage_content] = react_1.default.useState(null);
    const [title, settitle] = react_1.default.useState('');
    const [about, setabout] = react_1.default.useState('');
    const [description, setdescription] = react_1.default.useState('');
    const [source_url, setsource_url] = react_1.default.useState('');
    const [book_id, setbook_id] = react_1.default.useState('');
    const [copyFromArticle, setcopyFromArticle] = react_1.default.useState('');
    react_1.default.useEffect(() => {
        console.log('Page Creator page content', page_content);
    }, [page_content]);
    function submit() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () {
            return yield URLs_1.Api.createPage({
                title: title,
                about: about,
                description: description,
                source_url: source_url,
                page_content: page_content,
                book_id: book_id,
                copyFromArticle: copyFromArticle
            });
        }), (data) => {
            alert(data.success);
            setredirect(URLs_2.Routes.pageShow(data.id));
        }, 'PageCreator submit', true);
    }
    const [books, setbooks] = react_1.default.useState([]);
    function setup() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchBooks({ withoutPagination: true }); }), setbooks, 'PageCreator fetchBooks', true);
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    const [redirect, setredirect] = react_1.default.useState(null);
    if (redirect)
        return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "bg-white p-2" },
            react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: 'انشاء صفحة' }),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'input', onChange: (e) => settitle(e.target.value) })),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { "aria-label": "Default select example", onChange: e => {
                    setbook_id(e.target.value);
                }, value: book_id },
                react_1.default.createElement("option", null, "\u0627\u062E\u062A\u0631 \u0643\u062A\u0627\u0628"),
                books.map((book, bookIndex) => react_1.default.createElement("option", { key: bookIndex, value: book.id }, book.title))),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u062D\u0648\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 (\u0644\u0627\u064A\u0638\u0647\u0631 \u0644\u0644\u0645\u062A\u0635\u0641\u062D\u064A\u0646)"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setabout(e.target.value), rows: 3 })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0648\u0635\u0641 \u0627\u0644\u0645\u062D\u062A\u0648\u0649"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setdescription(e.target.value), rows: 3 })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0635\u062F\u0631"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'input', onChange: (e) => setsource_url(e.target.value) }))),
        react_1.default.createElement(SelectWithApiSearch_1.default, { setSelectedValue: setcopyFromArticle, label: 'النسخ من المقالة', paginationEndpoint: URLs_1.Api.fetchArticles, valueKeyWord: 'id', nameKeyWord: 'title', value: copyFromArticle }),
        copyFromArticle ? null : react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
            react_1.default.createElement(PageContentEditor_1.default, { setEditedPageContent: setpage_content })),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"));
}
exports.default = PageCreator;
